export default "__VITE_ASSET__DG7feHhA__"